module.exports = __webpack_public_path__ + "media/images/bg_diary-a291e18c5233dddc54a4a2807885c284.webp";